var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"students-list-cell"},[(_vm.row.getMsgrs())?_c('msgrs-list',{attrs:{"msgrs":_vm.row.getMsgrs(),"sendStatus":_vm.row.getSendStatus()}}):[_vm._v("-")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }